/* eslint-disable import/extensions */
import { INSIGN_PHASE } from '@inface-sdk/web-game-auth'
import { Feature } from '../common'
import { IacTerms } from '../iac/index.js'

class PlayNow extends Feature {
  /**
   * @param {object} param
   * @param {import('../../services').GameAuthService} param.gameAuthService
   */
  constructor({
    mainUrl, gameAuthService, infaceAuth, path,
  }) {
    super({ namespace: 'playnow', enumKey: 'PLAYNOW' })

    this.mainUrl = mainUrl || 'https://signin.nexon.com'
    this.gameAuthService = gameAuthService
    this.infaceAuth = infaceAuth
    this.path = path

    const {
      redirect_uri: redirectUri,
    } = this.queryParamWithCookie

    this.redirectUri = redirectUri ? decodeURIComponent(redirectUri) : ''
  }

  setCookie() {
    const cookieData = {
      ...this.queryParamWithCookie, // 쿼리 파람으로 읽어온 값을 쿠키에 저장
    }

    this.namespaceCookie.setCookie(cookieData)
  }

  routePage(path = this.path) {
    this.setCookie()
    this.gameAuthService.setPhase()
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/pages/account/${path.replace(/^\//, '')}`)
  }

  redirect() {
    super.redirect(this.redirectUri)
  }

  async redirectWithTransaction() {
    await this.gameAuthService.transactionByPhase(this.queryParamWithCookie)
    this.redirect()
  }

  async processPlayNowSignIn() {
    try {
      if (this.hasResponse()) {
        if (!this.hasError()) {
          window.$showLoginLoading()
        }
        this.redirect()
        return
      }

      await this.infaceAuth.init()

      // wt 존재 시 IAC flow
      if (this.infaceAuth.isSignedIn()) {
        const termsInstance = new IacTerms({ mainUrl: this.mainUrl, gameAuthService: this.gameAuthService })
        await termsInstance.getTermsFlow(INSIGN_PHASE.GA_LOGIN_WT_TERMS, { guid: await this.gameAuthService.insignGameAuth.guid })
        return
      }

      this.routePage()
    } catch (e) {
      console.error('[processPlayNowSignIn]', e)
    }
  }

  async processPlayNowSignOut() {
    try {
      if (!this.hasResponse()) {
        this.routePage()
        return
      }

      if (!this.hasError()) {
        await this.gameAuthService.processLogoutWithLC()
      }

      this.redirect()
    } catch (e) {
      console.error('[processPlayNowSignOut]', e)
    }
  }

  async processPlayNow() {
    try {
      if (!this.hasResponse()) {
        this.routePage()
        return
      }

      await this.redirectWithTransaction()
    } catch (e) {
      console.error('[processPlayNow]', e)
    }
  }
}

export default PlayNow
